export const defaultResponse = {
    estado: false,
    mensaje: null,
    error: null,
    token: null
}